import React from 'react';
import { motion } from 'framer-motion';
const rows = [{
  service: 'Desvanecido de Precisión',
  outcome: 'Entra a cualquier habitación con autoridad'
}, {
  service: 'Perfilado de Barba',
  outcome: 'Una mandíbula que impone respeto'
}, {
  service: 'Tratamiento con Toalla Caliente',
  outcome: 'El estrés desaparece, la confianza aumenta'
}, {
  service: 'Consulta de Estilo',
  outcome: 'Un look auténticamente tuyo'
}, {
  service: 'La Experiencia Completa',
  outcome: 'Te conviertes en la mejor versión de ti mismo'
}];
export function ComparisonTable() {
  return <section id="catalogo" className="py-24 md:py-32 container mx-auto px-6 md:px-12" data-id="element-28">
      <motion.div className="glass-card rounded-2xl overflow-hidden max-w-5xl mx-auto shadow-2xl shadow-gold/5" initial={{
      opacity: 0,
      y: 50
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-29">
        <div className="grid grid-cols-2 border-b border-white/10 bg-white/5 p-6 md:p-8" data-id="element-30">
          <h3 className="text-xs md:text-sm tracking-[0.2em] uppercase text-gold font-medium" data-id="element-31">
            El Servicio
          </h3>
          <h3 className="text-xs md:text-sm tracking-[0.2em] uppercase text-gold font-medium" data-id="element-32">
            El Resultado
          </h3>
        </div>

        <div className="flex flex-col" data-id="element-33">
          {rows.map((row, index) => <motion.div key={index} className={`grid grid-cols-2 p-6 md:p-8 hover:bg-white/5 transition-colors ${index !== rows.length - 1 ? 'border-b border-white/5' : ''}`} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-34">
              <div className="font-serif text-lg md:text-xl text-white/90 pr-4" data-id="element-35">
                {row.service}
              </div>
              <div className="font-light text-white/60 text-sm md:text-base flex items-center" data-id="element-36">
                {row.outcome}
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}